import { ApiClient as CommonApiClient } from '../../common/helpers/api-client/ApiClient'

export default class ApiClient extends CommonApiClient {
  static getAccountDocument () {
    return this.getUrl('profile/account#contract', true)
  }

  static changeUserLanguage (lang) {
    return this.options('site/change-language', { headers: { lang } })
  }

  static async options (url, config) {
    return this.axios()
      .options(this.getUrl(url), config)
      .catch(async error => {
        console.error(error.response)
      })
  }

  static getTranslations (params) {
    return this.get('translation/get-translation', {
      params,
      headers: this.getAuthHeaders()
    })
  }
}
